module.exports = "<svg id=\"Layer_1\" viewBox=\"0 0 74.5 74.5\"><style>.st0{fill:#fff}</style><path d=\"M30.6 61.2c-8.2 0-15.9-3.2-21.6-9C-3 40.3-3 20.9 9 9 20.9-3 40.3-3 52.2 9c11.9 11.9 11.9 31.3 0 43.3-5.7 5.7-13.4 8.9-21.6 8.9zM16 16c-8 8-8 21.1 0 29.1 3.9 3.9 9.1 6 14.6 6s10.7-2.1 14.6-6c8-8 8-21.1 0-29.1-8.1-8-21.1-8-29.2 0z\" class=\"st0\"></path><path d=\"M69.5 74.5c-1.3 0-2.6-.5-3.5-1.5L45.1 52.2c-2-2-2-5.1 0-7.1s5.1-2 7.1 0L73 66c2 2 2 5.1 0 7.1-1 .9-2.2 1.4-3.5 1.4z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/search.svg
// module id = 314
// module chunks = 1